export const SECONDS_PER_DAY = 8 * 3600;

let intlLocale = 'de-DE';
let intFmt = new Intl.NumberFormat(intlLocale, { maximumFractionDigits: 0 });
let dateFmt = new Intl.DateTimeFormat(intlLocale, { day: '2-digit', month: '2-digit', year: 'numeric' });
let datetimeFmt = new Intl.DateTimeFormat(intlLocale, {
  day: '2-digit', month: '2-digit', year: 'numeric',
  hour: '2-digit', minute: '2-digit',
});

export function setIntlLocale(locale: string): void {
  intlLocale = locale;
  intFmt = new Intl.NumberFormat(intlLocale, { maximumFractionDigits: 0 });
  dateFmt = new Intl.DateTimeFormat(intlLocale, { day: '2-digit', month: '2-digit', year: 'numeric' });
  datetimeFmt = new Intl.DateTimeFormat(intlLocale, {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export function fmtInt(n: number | null | undefined): string {
  if (n == null || !isFinite(n)) return '0';
  return intFmt.format(Math.round(n));
}

export function num(v: unknown): number | null {
  if (v == null || v === '') return null;
  const val = Array.isArray(v) ? v[0] : v;
  const n = parseFloat(String(val).replace(',', '.'));
  return isFinite(n) ? n : null;
}

export function secondsToDays(sec: unknown): number | null {
  const n = num(sec);
  return n == null ? null : n / SECONDS_PER_DAY;
}

export function formatDate(d: Date | string | number | null | undefined): string {
  if (d == null || d === '') return '';
  const date = d instanceof Date ? d : new Date(d as string | number);
  if (isNaN(date.getTime())) return '';
  return dateFmt.format(date);
}

export function formatDateTime(d: Date | string | number | null | undefined): string {
  if (d == null || d === '') return '';
  const date = d instanceof Date ? d : new Date(d as string | number);
  if (isNaN(date.getTime())) return '';
  return datetimeFmt.format(date);
}

// "2.345,67 KB" / "12,3 MB"
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
